/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityGroupResponse } from '../../models/facility-group-response';
import { FacilityGroupUpdateRequest } from '../../models/facility-group-update-request';

export interface UpdateFacilityGroup$Params {
  facilityGroupId: number;
      body: FacilityGroupUpdateRequest
}

export function updateFacilityGroup(http: HttpClient, rootUrl: string, params: UpdateFacilityGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityGroupResponse>> {
  const rb = new RequestBuilder(rootUrl, updateFacilityGroup.PATH, 'put');
  if (params) {
    rb.path('facilityGroupId', params.facilityGroupId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FacilityGroupResponse>;
    })
  );
}

updateFacilityGroup.PATH = '/api/facilitygroup/{facilityGroupId}';
